

























































































































































































































































































































































































import NonCommodityReviewWidget from '@/components/widgets//NonCommodityReviewWidget.vue';
import { default as Component } from 'vue-class-component';
import Format from '@/interfaces/Format';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import moment from 'moment';
import ProductData from '@/interfaces/ProductData';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';
import ThgServiceElliDefault from '@/models/thg/ThgServiceElliDefault';
const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  filters: {
    zip: formatProvider.zip(),
    date: formatProvider.date(),
    euro: formatProvider.euro(),
    euroFull: formatProvider.euroFull(),
    euroThree: formatProvider.euroThree()
  }
})
export default class ReviewWidget extends NonCommodityReviewWidget {
  protected isExtendedDataInitialized: boolean = false;

  created(): void {
    this.linkThgConfigExtendedData();
  }

  protected get productData(): ProductData {
    return this.store.state.nonCommodityProductData;
  }

  public get nonCommodityProduct(): NonCommodityProductFacade {
    return NonCommodityProductFacade.withData(this.productData);
  }

  public get thgConfig(): ThgServiceElliDefault {
    return ThgServiceElliDefault.instance;
  }

  get productPrice(): number | undefined {
    return this.thgConfig.isCustomerTypeBusiness
      ? this.nonCommodityProduct.getBasePrice(
          this.$store.getters.getSelectedVehicleType,
          this.thgConfig.selectedYearArray
        )
      : this.nonCommodityProduct.getBasePriceBrutto(
          this.$store.getters.getSelectedVehicleType,
          this.thgConfig.selectedYearArray
        );
  }

  get yearlyPrice() {
    return (getSelectedVehicleType, selectedYear) => {
      return this.thgConfig.isCustomerTypeBusiness
        ? this.nonCommodityProduct.getBasePrice(getSelectedVehicleType, [selectedYear])
        : this.nonCommodityProduct.getBasePriceBrutto(getSelectedVehicleType, [selectedYear]);
    };
  }

  get isNotCashBonus() {
    const keyPhrasesWhichRequirePaymentData = ['praemie', 'prämie'];
    const productCodeLower = this.store.state.nonCommodityProductData.productCode.toLowerCase();
    return !keyPhrasesWhichRequirePaymentData.some((phrase) => productCodeLower.includes(phrase));
  }

  protected get nonCommodityProductPrice(): number {
    return this.productPrice ?? 0;
  }

  get showBusinessInformation(): boolean {
    return this.isBusinessCustomer && this.isBusinessProduct;
  }

  get isBusinessCustomer(): boolean {
    return this.sessionState.business == 1;
  }

  get isEcoProduct(): boolean {
    return this.store.state.nonCommodityProductData.productCode.toLowerCase().includes('bonus');
  }

  get isVoucherProduct(): boolean {
    return this.store.state.nonCommodityProductData.productCode.toLowerCase().includes('voucher');
  }

  get isBusinessProduct(): boolean {
    return this.store.state.nonCommodityProductData.productCode.toLowerCase().includes('_b2b');
  }

  get formattedProductPrice(): string {
    return formatProvider.euro()(this.nonCommodityProductPrice);
  }

  get productName(): string {
    return this.store.state.nonCommodityProductData.name ?? '';
  }

  public get showSkipRevocationOption(): boolean {
    if (this.isBusinessCustomer) {
      this.skipRevocationProcess = true;
      return false;
    }
    return true;
  }

  public get skipRevocationProcess(): boolean {
    return this.thgConfig.getExtendedDataFieldValue(this.thgConfig.extendedDataKeySkipRevocationPeriods) == 'true';
  }

  public set skipRevocationProcess(doSkip: boolean) {
    this.thgConfig.setExtendedDataFieldValue(
      this.thgConfig.extendedDataKeySkipRevocationPeriods,
      doSkip ? 'true' : 'false'
    );
  }

  protected get dateTermsConfirmation(): string {
    return this.thgConfig.getExtendedDataFieldValue(this.thgConfig.extendedDataKeyDatesTermsConfirmation);
  }

  protected set dateTermsConfirmation(dateTermsConfirmation: string) {
    this.thgConfig.setExtendedDataFieldValue(
      this.thgConfig.extendedDataKeyDatesTermsConfirmation,
      dateTermsConfirmation
    );
  }

  public updateExtendedDataHook(): void {
    this.dateTermsConfirmation = moment().format('YYYY-MM-DDTHH:mm:ss[Z]');
  }
}
